import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import IPPBanner from "../../assets/bandner/IPPSWebsiteBanner.png";
import { useLanguage } from "../../i18n/LanguageContext";

export const CustomButton = ({
  text,
  color,
  bgColor,
  borderColor,
  fill,
  padding,
  href,
}) => {
  return (
    <Link to={href}>
      <button
        className={`${color} ${bgColor} ${fill} ${borderColor} ${padding} md:text-md text-md font-bold border-2 rounded-lg transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5`}
      >
        {text}
      </button>
    </Link>
  );
};

const Banner = () => {
  const { t } = useLanguage();

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 3000,
    dotsClass: "slick-dots",
    fade: true,
    cssEase: "ease-in-out",
  };

  const styleText2 =
    "w-full h-full text-white px-8 xl:px-4 text-start flex items-center justify-center";
  const styleText =
    " text-4xl font-semibold leading-[1.15] tracking-tight flex items-center justify-start h-full drop-shadow-lg";

  const slides = t("banner.slides", []);

  return (
    <div className="bg-gradient-to-b from-lightBlue via-blue to-darkBlue max-w-screen-3xl m-auto relative md:h-[26vh] lg:h-[30vh] xl:min-h-[500px] xl:max-h-[300px] overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(255,255,255,0.08)_0%,transparent_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,rgba(240,80,35,0.06)_0%,transparent_50%)]" />

      <div className="relative 2xl:max-w-screen-2xl m-auto h-full">
        <img
          src={IPPBanner}
          alt="IPPS banner"
          className="absolute z-10 hidden lg:flex right-0 bottom-0 object-fill lg:w-[38%] xl:w-[40%] drop-shadow-2xl"
        />
        <div className="relative overflow-hidden mx-auto sm:max-w-3xl lg:max-w-screen-2xl xl:min-h-[500px] xl:max-h-[300px]">
          <div className="hidden lg:flex px-2">
            <div className="absolute z-30 bottom-28 lg:bottom-[24vh] lg:left-8 xl:left-4 xl:bottom-20 flex justify-center gap-4">
              <CustomButton
                text={t("banner.ctaTalk")}
                color="text-white"
                borderColor="border-orange"
                fill="bg-orange hover:bg-pink"
                padding="md:py-3 md:px-6"
                href="/contact"
              />

              <CustomButton
                text={t("banner.ctaProducts")}
                color="text-white"
                borderColor="border-orange"
                fill="hover:bg-orange"
                padding="md:py-3 md:px-6"
                href="/products/treasury"
              />
            </div>
          </div>

          <div className="overflow-hidden relative h-[50vh]">
            <Slider
              {...settings}
              className="w-full h-full pt-[220px] md:pt-[150px] xl:pt-[200px]"
            >
              {slides.map((text, i) => (
                <div key={i} className={styleText2}>
                  <h1 className={styleText}>{text}</h1>
                </div>
              ))}
            </Slider>

            <div className="flex lg:hidden justify-center gap-3 mt-4 pb-6 px-4">
              <CustomButton
                text={t("banner.ctaTalk")}
                color="text-white"
                borderColor="border-orange"
                fill="bg-orange hover:bg-pink"
                padding="py-2.5 px-5"
                href="/contact"
              />
              <CustomButton
                text={t("banner.ctaProducts")}
                color="text-white"
                borderColor="border-orange"
                fill="hover:bg-orange"
                padding="py-2.5 px-5"
                href="/products/treasury"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
